

const categoryData = [
  { name: "Chauffage et ECS", id: "heatandwater" },
  { name: "Cuisson", id: "cooking" },
  { name: "Ventilation", id: "hvac" },
  { name: "Informatique", id: "it" },
];

const energyData = [
  { name: "Electricité", id: "electricity" },
  { name: "Gaz", id: "gas" },
  { name: "Eau", id: "water" },
  { name: "Chaleur", id: "heat" },
  { name: "Froid", id: "cold" },
  { name: "Propane", id: "propane" },
  { name: "Fioul", id: "fuel" },
  { name: "Bois", id: "wood" },
];

const consumptionpartmethodData = [
  { name: "Manuelle", id: "manual" },
  { name: "A partir des équipements", id: "equipments" },
  { name: "A partir des IoT", id: "iot" },
];

export { categoryData,  energyData, consumptionpartmethodData};
